import { PresentationStudyCardInfo } from './../../../models/search-result/PresentationStudyCardInfo';
import { Component, defineComponent, onMounted, toRef, Ref, watch } from 'vue';

import StudyCard from './StudyCard.class';
import StudyCardTrackingInformation from './tracking-info/StudyCardTrackingInformation.vue';
import { Mobile } from '../../../infrastructure/Mobile';

export default defineComponent({
	components: {
		StudyCardTrackingInformation: StudyCardTrackingInformation as Component
	},
	props: {
		presentationStudyCardInfo: PresentationStudyCardInfo
	},
	setup: (props: any) => {
		const presentationStudyCardInfo = toRef(props, 'presentationStudyCardInfo') as Ref<PresentationStudyCardInfo>;
		const component = new StudyCard(presentationStudyCardInfo);

		onMounted(component.mounted.bind(component));
		watch(component.userCurrency, component.getTuitionFee.bind(component));
		watch(component.userCountry, component.getTuitionFee.bind(component));

		return {
			rankingPercentageRef: component.rankingPercentageRef,
			isMasters: component.isMasters,
			degreeTypeCriteria: component.degreeTypeCriteria,
			deliveryMethodCriteria: component.deliveryMethodCriteria,
			creditsCriteria: component.creditsCriteria,
			trackClick: component.trackClick.bind(component),
			trackImpression: component.trackImpression.bind(component),
			id: component.presentationStudyCardInfo.value?.id,
			level: component.getLevel,
			title: component.getTitle,
			programmeLink: component.getProgrammeLink,
			summary: component.getSummary,
			degree: component.getDegree,
			canShowLogo: component.canShowLogo,
			organisationLogo: component.organisationLogo,
			organisationName: component.organisationName,
			organisationId: component.organisationId,
			location: component.getLocation,
			enhanced: component.presentationStudyCardInfo.value?.enhanced,
			attendance: component.getAttendanceMethods,
			deliveryMethod: component.getDeliveryMethods,
			duration: component.getDuration,
			tuitionFee: component.tuitionFee,
			tuitionFeeDiscount: component.tuitionFeeDiscount,
			hideTuitionFeePreDiscount: component.noDiscountedAmount,
			canShowIUIncentive: component.canShowIUIncentive,
			canShowIUDiscountInfo: component.canShowIUDiscountInfo,
			currencyUnit: component.currencyUnit,
			tuitionUnit: component.tuitionUnit,
			isMobile: Mobile.instance.isMobile,
			canShowUniversityGlobalPositionPercentage: component.canShowUniversityGlobalPositionPercentage,
			universityGlobalPositionPercentage: component.universityGlobalPositionPercentage
		};
	}
});
